{
	"asset":{
		"generator":"Khronos glTF Blender I/O v4.1.63",
		"version":"2.0"
	},
	"scene":0,
	"scenes":[
		{
			"name":"Scene",
			"nodes":[
				0,
				1,
				2,
				3,
				4,
				5,
				6,
				7,
				8,
				9,
				10
			]
		}
	],
	"nodes":[
		{
			"mesh":0,
			"name":"head.019",
			"scale":[
				0.8984315395355225,
				0.9587109684944153,
				0.9587109684944153
			],
			"translation":[
				0,
				3.987575054168701,
				0
			]
		},
		{
			"mesh":1,
			"name":"Cube.080",
			"rotation":[
				0,
				0,
				-0.18234197795391083,
				0.9832351803779602
			],
			"scale":[
				-0.608928382396698,
				-0.608928382396698,
				-0.6089284420013428
			],
			"translation":[
				-0.8017759919166565,
				4.231659889221191,
				0.34039801359176636
			]
		},
		{
			"mesh":2,
			"name":"Cube.081",
			"rotation":[
				0,
				0,
				-0.18234197795391083,
				0.9832351803779602
			],
			"scale":[
				-0.608928382396698,
				-0.608928382396698,
				-0.6089284420013428
			],
			"translation":[
				-0.8017759919166565,
				4.231659889221191,
				-0.34039801359176636
			]
		},
		{
			"mesh":3,
			"name":"Cube.082",
			"rotation":[
				0.7071068286895752,
				0,
				0,
				0.7071068286895752
			],
			"scale":[
				-0.6089284420013428,
				-0.6089284420013428,
				-0.6089284420013428
			],
			"translation":[
				-0.8017759919166565,
				3.793959140777588,
				0
			]
		},
		{
			"mesh":4,
			"name":"body.019",
			"scale":[
				0.937124490737915,
				1,
				1
			],
			"translation":[
				0,
				2.146585464477539,
				0
			]
		},
		{
			"mesh":5,
			"name":"foot left.020",
			"rotation":[
				0,
				0,
				0.14361350238323212,
				0.9896338582038879
			],
			"scale":[
				0.18387234210968018,
				0.18387234210968018,
				0.18387234210968018
			],
			"translation":[
				0.822985827922821,
				0.22252193093299866,
				-0.4628182053565979
			]
		},
		{
			"mesh":6,
			"name":"foot right.020",
			"rotation":[
				0,
				0,
				-0.1516585648059845,
				0.9884329438209534
			],
			"scale":[
				0.18387234210968018,
				0.18387234210968018,
				0.18387234210968018
			],
			"translation":[
				-0.8037128448486328,
				0.12823782861232758,
				0.5771837830543518
			]
		},
		{
			"mesh":7,
			"name":"hand left.020",
			"rotation":[
				0.18794599175453186,
				-0.05200012028217316,
				-0.2588181495666504,
				0.9460367560386658
			],
			"scale":[
				0.30448251962661743,
				0.5152471661567688,
				0.5152481198310852
			],
			"translation":[
				-0.5479605197906494,
				2.2653894424438477,
				-1.5375065803527832
			]
		},
		{
			"mesh":8,
			"name":"hand right.020",
			"rotation":[
				0.5067139863967896,
				0.11085695028305054,
				0.1816861778497696,
				0.8354290723800659
			],
			"scale":[
				0.30448251962661743,
				0.5152471661567688,
				0.5152481198310852
			],
			"translation":[
				0.39582735300064087,
				2.2653884887695312,
				1.5375065803527832
			]
		},
		{
			"mesh":9,
			"name":"leg left.020",
			"rotation":[
				0,
				0,
				0.228352889418602,
				0.9735784530639648
			],
			"scale":[
				0.08088663965463638,
				0.9437786340713501,
				0.0863136574625969
			],
			"translation":[
				0.5459060072898865,
				0.9646562337875366,
				-0.46000000834465027
			]
		},
		{
			"mesh":10,
			"name":"leg right.020",
			"rotation":[
				0,
				0,
				-0.16289430856704712,
				0.9866435527801514
			],
			"scale":[
				0.08088663965463638,
				0.9437787532806396,
				0.0863136574625969
			],
			"translation":[
				-0.5067042708396912,
				0.9103175401687622,
				0.46000000834465027
			]
		}
	],
	"materials":[
		{
			"doubleSided":true,
			"name":"Material.019",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0,
					0.8108825087547302,
					0.002020560670644045,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.5
			}
		},
		{
			"doubleSided":true,
			"name":"Material.024",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0,
					0.0036458494141697884,
					0.043452225625514984,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.5
			}
		},
		{
			"doubleSided":true,
			"name":"Material.018",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0,
					0.0036458494141697884,
					0.043452225625514984,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.5
			}
		},
		{
			"doubleSided":true,
			"name":"Material.005",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0,
					0.8108825087547302,
					0.002020560670644045,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.5
			}
		}
	],
	"meshes":[
		{
			"name":"Cube.308",
			"primitives":[
				{
					"attributes":{
						"POSITION":0,
						"NORMAL":1,
						"TEXCOORD_0":2
					},
					"indices":3,
					"material":0
				}
			]
		},
		{
			"name":"Cube.305",
			"primitives":[
				{
					"attributes":{
						"POSITION":4,
						"NORMAL":5,
						"TEXCOORD_0":6
					},
					"indices":7,
					"material":1
				}
			]
		},
		{
			"name":"Cube.306",
			"primitives":[
				{
					"attributes":{
						"POSITION":8,
						"NORMAL":9,
						"TEXCOORD_0":10
					},
					"indices":7,
					"material":2
				}
			]
		},
		{
			"name":"Cube.307",
			"primitives":[
				{
					"attributes":{
						"POSITION":11,
						"NORMAL":12,
						"TEXCOORD_0":13
					},
					"indices":14,
					"material":2
				}
			]
		},
		{
			"name":"Cube.309",
			"primitives":[
				{
					"attributes":{
						"POSITION":15,
						"NORMAL":16,
						"TEXCOORD_0":17
					},
					"indices":18,
					"material":0
				}
			]
		},
		{
			"name":"Cube.222",
			"primitives":[
				{
					"attributes":{
						"POSITION":19,
						"NORMAL":20,
						"TEXCOORD_0":21
					},
					"indices":22,
					"material":0
				}
			]
		},
		{
			"name":"Cube.223",
			"primitives":[
				{
					"attributes":{
						"POSITION":23,
						"NORMAL":24,
						"TEXCOORD_0":25
					},
					"indices":22,
					"material":0
				}
			]
		},
		{
			"name":"Cube.224",
			"primitives":[
				{
					"attributes":{
						"POSITION":26,
						"NORMAL":27,
						"TEXCOORD_0":28
					},
					"indices":29,
					"material":3
				}
			]
		},
		{
			"name":"Cube.225",
			"primitives":[
				{
					"attributes":{
						"POSITION":30,
						"NORMAL":31,
						"TEXCOORD_0":32
					},
					"indices":33,
					"material":3
				}
			]
		},
		{
			"name":"Cylinder.054",
			"primitives":[
				{
					"attributes":{
						"POSITION":34,
						"NORMAL":35,
						"TEXCOORD_0":36
					},
					"indices":37,
					"material":0
				}
			]
		},
		{
			"name":"Cylinder.055",
			"primitives":[
				{
					"attributes":{
						"POSITION":38,
						"NORMAL":39,
						"TEXCOORD_0":40
					},
					"indices":37,
					"material":0
				}
			]
		}
	],
	"accessors":[
		{
			"bufferView":0,
			"componentType":5126,
			"count":368,
			"max":[
				0.9663493633270264,
				0.7516860961914062,
				0.9663493633270264
			],
			"min":[
				-0.9663493633270264,
				-0.7516862154006958,
				-0.9663493633270264
			],
			"type":"VEC3"
		},
		{
			"bufferView":1,
			"componentType":5126,
			"count":368,
			"type":"VEC3"
		},
		{
			"bufferView":2,
			"componentType":5126,
			"count":368,
			"type":"VEC2"
		},
		{
			"bufferView":3,
			"componentType":5123,
			"count":516,
			"type":"SCALAR"
		},
		{
			"bufferView":4,
			"componentType":5126,
			"count":24,
			"max":[
				0.12331390380859375,
				0.3768068552017212,
				0.13226842880249023
			],
			"min":[
				-0.12331390380859375,
				-0.3768068552017212,
				-0.13226830959320068
			],
			"type":"VEC3"
		},
		{
			"bufferView":5,
			"componentType":5126,
			"count":24,
			"type":"VEC3"
		},
		{
			"bufferView":6,
			"componentType":5126,
			"count":24,
			"type":"VEC2"
		},
		{
			"bufferView":7,
			"componentType":5123,
			"count":36,
			"type":"SCALAR"
		},
		{
			"bufferView":8,
			"componentType":5126,
			"count":24,
			"max":[
				0.12331390380859375,
				0.3768068552017212,
				0.13226842880249023
			],
			"min":[
				-0.12331390380859375,
				-0.3768068552017212,
				-0.13226830959320068
			],
			"type":"VEC3"
		},
		{
			"bufferView":9,
			"componentType":5126,
			"count":24,
			"type":"VEC3"
		},
		{
			"bufferView":10,
			"componentType":5126,
			"count":24,
			"type":"VEC2"
		},
		{
			"bufferView":11,
			"componentType":5126,
			"count":24,
			"max":[
				0.12331390380859375,
				0.3768068552017212,
				0.23079679906368256
			],
			"min":[
				-0.12331390380859375,
				-0.3768068552017212,
				-0.13226830959320068
			],
			"type":"VEC3"
		},
		{
			"bufferView":12,
			"componentType":5126,
			"count":24,
			"type":"VEC3"
		},
		{
			"bufferView":13,
			"componentType":5126,
			"count":24,
			"type":"VEC2"
		},
		{
			"bufferView":14,
			"componentType":5123,
			"count":36,
			"type":"SCALAR"
		},
		{
			"bufferView":15,
			"componentType":5126,
			"count":224,
			"max":[
				0.9102854132652283,
				1.0557153224945068,
				0.9102854132652283
			],
			"min":[
				-0.9102854132652283,
				-0.9018439054489136,
				-0.9102854132652283
			],
			"type":"VEC3"
		},
		{
			"bufferView":16,
			"componentType":5126,
			"count":224,
			"type":"VEC3"
		},
		{
			"bufferView":17,
			"componentType":5126,
			"count":224,
			"type":"VEC2"
		},
		{
			"bufferView":18,
			"componentType":5123,
			"count":324,
			"type":"SCALAR"
		},
		{
			"bufferView":19,
			"componentType":5126,
			"count":30,
			"max":[
				1.3272992372512817,
				0.21638387441635132,
				1
			],
			"min":[
				-2.4162750244140625,
				-1,
				-1.789177417755127
			],
			"type":"VEC3"
		},
		{
			"bufferView":20,
			"componentType":5126,
			"count":30,
			"type":"VEC3"
		},
		{
			"bufferView":21,
			"componentType":5126,
			"count":30,
			"type":"VEC2"
		},
		{
			"bufferView":22,
			"componentType":5123,
			"count":48,
			"type":"SCALAR"
		},
		{
			"bufferView":23,
			"componentType":5126,
			"count":30,
			"max":[
				1.3272992372512817,
				0.21638387441635132,
				1
			],
			"min":[
				-2.4162750244140625,
				-1,
				-1.7891775369644165
			],
			"type":"VEC3"
		},
		{
			"bufferView":24,
			"componentType":5126,
			"count":30,
			"type":"VEC3"
		},
		{
			"bufferView":25,
			"componentType":5126,
			"count":30,
			"type":"VEC2"
		},
		{
			"bufferView":26,
			"componentType":5126,
			"count":72,
			"max":[
				1.3481192588806152,
				0.6197910308837891,
				0.5966057777404785
			],
			"min":[
				-0.8679153919219971,
				-0.9439473152160645,
				-0.5283350944519043
			],
			"type":"VEC3"
		},
		{
			"bufferView":27,
			"componentType":5126,
			"count":72,
			"type":"VEC3"
		},
		{
			"bufferView":28,
			"componentType":5126,
			"count":72,
			"type":"VEC2"
		},
		{
			"bufferView":29,
			"componentType":5123,
			"count":132,
			"type":"SCALAR"
		},
		{
			"bufferView":30,
			"componentType":5126,
			"count":72,
			"max":[
				1.3481193780899048,
				0.44371485710144043,
				0.9865543842315674
			],
			"min":[
				-0.8679153919219971,
				-0.5842263102531433,
				-0.6333475112915039
			],
			"type":"VEC3"
		},
		{
			"bufferView":31,
			"componentType":5126,
			"count":72,
			"type":"VEC3"
		},
		{
			"bufferView":32,
			"componentType":5126,
			"count":72,
			"type":"VEC2"
		},
		{
			"bufferView":33,
			"componentType":5123,
			"count":132,
			"type":"SCALAR"
		},
		{
			"bufferView":34,
			"componentType":5126,
			"count":192,
			"max":[
				1,
				1,
				1
			],
			"min":[
				-1,
				-1,
				-1
			],
			"type":"VEC3"
		},
		{
			"bufferView":35,
			"componentType":5126,
			"count":192,
			"type":"VEC3"
		},
		{
			"bufferView":36,
			"componentType":5126,
			"count":192,
			"type":"VEC2"
		},
		{
			"bufferView":37,
			"componentType":5123,
			"count":372,
			"type":"SCALAR"
		},
		{
			"bufferView":38,
			"componentType":5126,
			"count":192,
			"max":[
				1,
				1,
				1
			],
			"min":[
				-1,
				-1,
				-1
			],
			"type":"VEC3"
		},
		{
			"bufferView":39,
			"componentType":5126,
			"count":192,
			"type":"VEC3"
		},
		{
			"bufferView":40,
			"componentType":5126,
			"count":192,
			"type":"VEC2"
		}
	],
	"bufferViews":[
		{
			"buffer":0,
			"byteLength":4416,
			"byteOffset":0,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":4416,
			"byteOffset":4416,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":2944,
			"byteOffset":8832,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1032,
			"byteOffset":11776,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":288,
			"byteOffset":12808,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":288,
			"byteOffset":13096,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":192,
			"byteOffset":13384,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":72,
			"byteOffset":13576,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":288,
			"byteOffset":13648,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":288,
			"byteOffset":13936,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":192,
			"byteOffset":14224,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":288,
			"byteOffset":14416,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":288,
			"byteOffset":14704,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":192,
			"byteOffset":14992,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":72,
			"byteOffset":15184,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":2688,
			"byteOffset":15256,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":2688,
			"byteOffset":17944,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1792,
			"byteOffset":20632,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":648,
			"byteOffset":22424,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":360,
			"byteOffset":23072,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":360,
			"byteOffset":23432,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":240,
			"byteOffset":23792,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":96,
			"byteOffset":24032,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":360,
			"byteOffset":24128,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":360,
			"byteOffset":24488,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":240,
			"byteOffset":24848,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":864,
			"byteOffset":25088,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":864,
			"byteOffset":25952,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":576,
			"byteOffset":26816,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":264,
			"byteOffset":27392,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":864,
			"byteOffset":27656,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":864,
			"byteOffset":28520,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":576,
			"byteOffset":29384,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":264,
			"byteOffset":29960,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":2304,
			"byteOffset":30224,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":2304,
			"byteOffset":32528,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1536,
			"byteOffset":34832,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":744,
			"byteOffset":36368,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":2304,
			"byteOffset":37112,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":2304,
			"byteOffset":39416,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1536,
			"byteOffset":41720,
			"target":34962
		}
	],
	"buffers":[
		{
			"byteLength":43256,
			"uri":"player_green_walk1.bin"
		}
	]
}
